import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ROUTES } from "@/app/routes";
import { SidebarNavigation, SidebarUserSection } from "@/components/shared/navigation/Sidebar";
import { useCurrentOrganization, useOrganizations } from "@/hooks/organization";
import { useAuth } from "@/hooks/useAuth";
import { useLogger } from "@/hooks/useLogger";
import { useEditorPanelStore } from "@/stores/useEditorPanelStore";
import { cn } from "@/utils";

export const EditorSidebarBody = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logger = useLogger();
  const { logout, user } = useAuth();
  const { organizationDetails, userOrganizations } = useOrganizations();
  const currentOrganization = useCurrentOrganization();
  const isSidebarOpen = useEditorPanelStore((state) => state.isSidebarOpen);
  const closeSidebar = useEditorPanelStore((state) => state.closeSidebar);
  const [showUserMenu, setShowUserMenu] = useState(false);

  useEffect(() => {
    closeSidebar();
  }, [location.pathname, closeSidebar]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate(ROUTES.AUTH.LOGIN);
    } catch (error) {
      logger.error("Logout failed:", error);
    }
  };

  return (
    <aside
      className={cn(
        "flex-shrink-0 overflow-hidden bg-[var(--sidebar-default-bg)] border-r border-[var(--sidebar-default-border)] transition-[width] duration-200 ease-out",
        isSidebarOpen ? "w-sidebar-expanded" : "w-0",
      )}
      aria-hidden={!isSidebarOpen}
    >
      <div className="w-sidebar-expanded h-full flex flex-col">
        <SidebarNavigation isCollapsed={false} onExpand={() => {}} variant="default" />
        <SidebarUserSection
          isCollapsed={false}
          user={user}
          showMenu={showUserMenu}
          onToggleMenu={() => setShowUserMenu((prev) => !prev)}
          variant="default"
          organizationDetails={organizationDetails}
          currentOrganization={currentOrganization}
          userOrganizations={userOrganizations}
          onLogout={handleLogout}
        />
      </div>
    </aside>
  );
};
